import { Button, Form, Modal, Select } from 'antd';
import {
  CompanyMobileActionButton,
  CompanyMobileField,
  CompanyMobileFilterActions,
  CompanyMobileFilterApplyButton,
  CompanyMobileFilterButton,
  CompanyMobileFilterDrawer,
  CompanyMobileFilterField,
  CompanyMobileFilterFields,
  CompanyMobileFilterForm,
  CompanyMobileFilterRow,
  CompanyMobileFilterSelect,
  CompanyMobileHeaderActions,
  CompanyMobileIconButton,
  CompanyMobilePage,
  CompanyMobilePageButton,
  CompanyMobilePagination,
  CompanyMobilePaginationActions,
  CompanyMobilePaginationInfo,
  CompanyMobileSearch,
  CompanyMobileSecondaryButton,
  CompanyMobileSection,
  CompanyMobileSectionHeader,
  CompanyMobileSwitchField,
  MobileCompanyHeader,
} from '../company/mobile';
import styled from 'styled-components';

export const OperationModeMobilePage = CompanyMobilePage;
export const OperationModeMobileHeader = MobileCompanyHeader;
export const OperationModeMobileHeaderActions = CompanyMobileHeaderActions;
export const OperationModeMobileActionButton = CompanyMobileActionButton;
export const OperationModeMobileSecondaryButton = CompanyMobileSecondaryButton;
export const OperationModeMobileIconButton = CompanyMobileIconButton;
export const OperationModeMobileFilterRow = CompanyMobileFilterRow;
export const OperationModeMobileSearch = CompanyMobileSearch;
export const OperationModeMobileFilterButton = CompanyMobileFilterButton;
export const OperationModeMobileFilterDrawer = CompanyMobileFilterDrawer;
export const OperationModeMobileFilterForm = CompanyMobileFilterForm;
export const OperationModeMobileFilterFields = CompanyMobileFilterFields;
export const OperationModeMobileFilterField = CompanyMobileFilterField;
export const OperationModeMobileFilterSelect = CompanyMobileFilterSelect;
export const OperationModeMobileFilterActions = CompanyMobileFilterActions;
export const OperationModeMobileFilterApplyButton =
  CompanyMobileFilterApplyButton;
export const OperationModeMobilePagination = CompanyMobilePagination;
export const OperationModeMobilePaginationInfo = CompanyMobilePaginationInfo;
export const OperationModeMobilePaginationActions =
  CompanyMobilePaginationActions;
export const OperationModeMobilePageButton = CompanyMobilePageButton;
export const OperationModeMobileEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
  padding: 16px;
  border: 1px solid #e8ecf3;
  border-radius: 6px;
  background: #ffffff;
  color: #768499;
  font-size: 14px;
  text-align: center;
`;
export const OperationModeMobileForm = styled.div`
  width: 100%;
  padding: 12px 0 24px;
`;

export const OperationModeMobileSection = styled(CompanyMobileSection)`
  margin-bottom: 16px;
  padding-bottom: ${(props) => (props.$bordered ? '24px' : '0')};
`;

export const OperationModeMobileSectionHeader = styled(
  CompanyMobileSectionHeader,
)`
  margin-bottom: 8px;

  h2 {
    font-size: 14px;
    line-height: 1.2;
  }

  p {
    margin-top: 8px;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const OperationModeMobileField = styled(CompanyMobileField)`
  && {
    margin-bottom: 8px;
  }
`;

export const OperationModeMobileSwitchField = CompanyMobileSwitchField;

export const OperationModeMobileRadioRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  width: 100%;

  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .ant-radio-wrapper {
    margin-right: 0;
    color: #000000;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const OperationModeMobileTableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;
`;

export const OperationModeMobileTable = styled.table<{ $minWidth?: number }>`
  width: ${(props) => props.$minWidth ?? 900}px;
  min-width: ${(props) => props.$minWidth ?? 900}px;
  border-collapse: collapse;
  background: #ffffff;

  thead tr {
    height: 46px;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
  }

  th {
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    text-align: left;
    white-space: nowrap;
  }

  th:last-child {
    border-right: 0;
  }

  tbody tr {
    min-height: 48px;
    border-bottom: 1px solid #e8ecf3;
  }

  td {
    padding: 16px 12px;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    vertical-align: middle;
    white-space: nowrap;
  }
`;

export const OperationModeMobileLinkText = styled.button`
  display: inline-flex;
  max-width: 180px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0e3b7a;
  font-size: 12px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
`;

export const OperationModeMobileDeviceCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #1e1e1e;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  }

  span {
    color: #595959;
    font-size: 10px;
    line-height: 1;
    letter-spacing: 0.2px;
  }
`;

export const OperationModeMobileStatus = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid ${(props) => (props.$active ? '#52c41a' : '#eeb141')};
  border-radius: 5px;
  background: ${(props) => (props.$active ? '#f6ffed' : '#fffbe7')};
  color: ${(props) => (props.$active ? '#52c41a' : '#eeb141')};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-transform: capitalize;
`;

export const OperationModeMobileMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1e1e1e;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const OperationModeMobileDetailModal = styled(Modal)`
  .ant-modal-content {
    padding: 12px;
    border-radius: 8px;
  }

  .ant-modal-header {
    margin-bottom: 12px;
    padding: 0;
  }

  .ant-modal-title {
    padding-right: 24px;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
  }

  .ant-modal-close {
    top: 18px;
    right: 12px;
  }

  .ant-modal-body {
    padding: 0;
  }
`;

export const OperationModeMobileConstantModal = styled(Modal)`
  .ant-modal-content {
    padding: 12px;
    border-radius: 8px;
  }

  .ant-modal-header {
    min-height: 52px;
    margin-bottom: 8px;
    padding: 0;
  }

  .ant-modal-title {
    padding: 8px 26px 8px 0;
    color: #1e1e1e;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
  }

  .ant-modal-close {
    top: 22px;
    right: 12px;
  }

  .ant-modal-body {
    padding: 0;
  }
`;

export const OperationModeMobileConstantForm = styled.div`
  width: 100%;

  .ant-form-item {
    margin-bottom: 8px;
  }

  .ant-form-item-label {
    padding-bottom: 3px;
  }

  .ant-form-item-label > label {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-form-item-required::before {
    margin-inline-end: 5px !important;
    color: #ff3a3a !important;
    font-family: Roboto, sans-serif !important;
    font-size: 12px !important;
    line-height: 18px !important;
  }

  .ant-input,
  .ant-input-affix-wrapper {
    height: 44px;
    border-color: #e8ecf3;
    border-radius: 6px;
    box-shadow: none;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
  }

  .ant-input-affix-wrapper {
    padding: 0 10px;
  }

  .ant-input-affix-wrapper .ant-input {
    height: 42px;
    border: 0;
  }

  .ant-input-suffix {
    color: #000000;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const OperationModeMobileConstantSwitchField = styled(
  OperationModeMobileField,
)`
  && {
    margin-bottom: 8px;
  }

  .ant-form-item-control-input {
    min-height: 22px;
  }
`;

export const OperationModeMobileConstantActions = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #e8ecf3;
`;

export const OperationModeMobileConstantCancelButton = styled(Button)`
  && {
    flex: 1 1 0;
    height: 34px;
    border-color: #e8ecf3;
    border-radius: 6px;
    background: #ffffff;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const OperationModeMobileConstantSaveButton = styled(Button)`
  && {
    flex: 1 1 0;
    height: 34px;
    border-radius: 6px;
    background: #264284;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  &&:hover,
  &&:focus {
    background: #264284;
    color: #ffffff;
  }
`;

export const OperationModeMobileWarningCard = styled.div`
  width: 100%;
  margin-bottom: 12px;
  padding: 8px 10px;
  border: 1px solid #fbe59a;
  border-radius: 6px;
  background: #fffbe7;
  color: #000000;
  font-size: 12px;
  line-height: 1.2;

  div + div {
    margin-top: 8px;
  }

  strong {
    font-weight: 600;
  }
`;

export const OperationModeMobileDetailActionRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  ${OperationModeMobileFilterRow} {
    flex: 1 1 auto;
    min-width: 0;
  }
`;

export const OperationModeMobileAddSquareButton = styled(Button)`
  && {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: #264284;
    color: #ffffff;
  }

  &&:hover,
  &&:focus {
    background: #264284;
    color: #ffffff;
  }
`;

export const OperationModeMobileHiddenFilter = styled.div`
  display: none;
`;

export const OperationModeMobileSelect = styled(Select)`
  && {
    width: 100%;
  }
`;

export const OperationModeMobileDateField = styled(Form.Item)`
  && {
    width: 100%;
    margin-bottom: 8px;
  }

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .ant-form-item-label > label {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-picker {
    width: 100%;
    height: 44px;
    border-color: #e8ecf3;
    border-radius: 6px;
    box-shadow: none;
  }
`;
